import {IMacronutrientDistributionValues} from './interfaces/macronutrient-distribution-values.interface';
import {DistributionPropertyG} from './classes/distribution-property-g';
import {DistributionPropertyPercentage} from './classes/distribution-property-percentage';
import {MacronutrientDistribution} from './macronutrient-distribution';

export class SmaeStrategy extends MacronutrientDistribution {
  /*
  * Josué Caro, [21/03/23 15:40]
  * Proteínas: Entre el 10% y el 15% de la ingesta calórica diaria.
  * Lípidos: Entre el 20% y el 30% de la ingesta calórica diaria, con un límite del 10% de grasas saturadas y menos del 1% de grasas trans en la dieta.
  * Carbohidratos: Entre el 50% y el 60% de la ingesta calórica diaria.
  * HC 60%
  * LIP 25%
  * PRO 15%
  *
  * */
  constructor() {
    super();
    this.carbohydrates = new DistributionPropertyPercentage('H. de carbono', { minimum: 50, maximum: 60 }, 60, 'icons8-trigo-50.png');
    this.lipids = new DistributionPropertyPercentage('Grasas', { minimum: 20, maximum: 30 }, 25, 'icons8-sashimi-50.png');
    this.protein = new DistributionPropertyPercentage('Proteínas', { minimum: 10, maximum: 15 }, 15, 'icons8-filete-50.png');
    this.fiber = new DistributionPropertyG('Fibra', 0, 0, 'icons8-hoja-50.png');
  }

  init(value: IMacronutrientDistributionValues): void {
    // suma de gramos
    const total = value.carbohydrate_g + value.dietaryFiber_g + value.totalFat_g + value.protein_g;

    this.carbohydrates.setValue(
      value.carbohydrate_g > 0 ?
        Math.round(((value.carbohydrate_g * 100) / total)) :
        60
    );
    this.lipids.setValue(
      value.totalFat_g > 0 ?
        Math.round(((value.totalFat_g * 100) / total)) :
        25
    );
    this.protein.setValue(
      value.protein_g > 0 ?
        Math.round(((value.protein_g * 100) / total)) :
        15
    );
    this.fiber.setValue(
      value.dietaryFiber_g > 0 ?
        Math.round(((value.dietaryFiber_g * 100) / total)) :
        0
    );
  }
}
